// Local translations — the copy is screen 11 of the QL-375 design.
export const T = {
  en_GB: {
    title: "Mandate rules",
    description:
      "How every mandate used in this collection is enforced. Templates carry the allocation; the rules are here.",
    blockLevel: "Where a breach blocks",
    blockLevelHint:
      "Goal judges the goal's portfolios combined. Portfolio judges each one on its own, which is the stricter of the two.",
    blockLevelGoal: "Goal",
    blockLevelPortfolio: "Portfolio",
    oneTimeBasis: "One-time portfolios are checked on",
    oneTimeBasisHint:
      "The final portfolio is what the client ends up holding. Purchases are only the new money. They differ only in a follow-up.",
    oneTimeBasisFinal: "Final portfolio",
    oneTimeBasisBuy: "Purchases",
    allowOneTimeDeviation: "Allow one-time deviation",
    allowOneTimeDeviationHint:
      "The advisor may accept a breach on one-time investments with a mandatory note, instead of being blocked.",
    allowRecurringDeviation: "Allow recurring deviation",
    allowRecurringDeviationHint: "The same, for recurring instructions.",
    // QL-664 — goal-level blocking and the buy basis cannot be combined.
    blockLevelGoalDisabledHint:
      "Goal is unavailable while one-time portfolios are checked on purchases — purchases are one portfolio's new money.",
    oneTimeBasisBuyDisabledHint:
      "Purchases is unavailable while a breach blocks on the goal — purchases are one portfolio's new money.",
    // QL-677
    allowCreateFromPortfolio: "Allow creation of mandate from portfolio",
    allowCreateFromPortfolioHint:
      "Advisors may make a custom portfolio the goal's mandate; the mandate then follows that portfolio. A mandate already created this way keeps following its portfolio when this is switched off.",
    affectedBasisToast: (count: string) =>
      `${count} open advice(s) keep a mandate that follows a portfolio. They continue until a template is selected there.`,
    failedToSave: "Failed to save mandate rules",
  },
  nb_NO: {
    title: "Mandatregler",
    description:
      "Hvordan hvert mandat som brukes i denne samlingen håndheves. Malene bærer allokeringen; reglene er her.",
    blockLevel: "Hvor et brudd blokkerer",
    blockLevelHint:
      "Mål vurderer målets porteføljer samlet. Portefølje vurderer hver enkelt for seg, som er den strengeste av de to.",
    blockLevelGoal: "Mål",
    blockLevelPortfolio: "Portefølje",
    oneTimeBasis: "Engangsporteføljer kontrolleres mot",
    oneTimeBasisHint:
      "Den endelige porteføljen er det kunden ender opp med å eie. Kjøpene er bare de nye pengene. De skiller seg bare i en oppfølging.",
    oneTimeBasisFinal: "Endelig portefølje",
    oneTimeBasisBuy: "Kjøp",
    allowOneTimeDeviation: "Tillat avvik ved engangsinvestering",
    allowOneTimeDeviationHint:
      "Rådgiveren kan godta et brudd ved engangsinvesteringer med en obligatorisk merknad, i stedet for å bli blokkert.",
    allowRecurringDeviation: "Tillat avvik ved spareavtale",
    allowRecurringDeviationHint: "Det samme, for faste instruksjoner.",
    blockLevelGoalDisabledHint:
      "Mål er utilgjengelig mens engangsporteføljer kontrolleres mot kjøpene — kjøpene er én porteføljes nye penger.",
    oneTimeBasisBuyDisabledHint:
      "Kjøp er utilgjengelig mens et brudd blokkerer på målet — kjøpene er én porteføljes nye penger.",
    allowCreateFromPortfolio: "Tillat opprettelse av mandat fra portefølje",
    allowCreateFromPortfolioHint:
      "Rådgivere kan gjøre en egendefinert portefølje til målets mandat; mandatet følger da porteføljen. Et mandat som allerede er opprettet slik, fortsetter å følge porteføljen når dette slås av.",
    affectedBasisToast: (count: string) =>
      `${count} åpne råd beholder et mandat som følger en portefølje. De fortsetter til en mal velges der.`,
    failedToSave: "Kunne ikke lagre mandatregler",
  },
} as const;
